import { render } from "./ListHeader.vue?vue&type=template&id=c87a30aa"
import script from "./ListHeader.vue?vue&type=script&lang=js"
export * from "./ListHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__